import styled, { keyframes } from 'styled-components';

const rotateAnimation = keyframes`
0% {
  filter: blur(10);
}
100% {
  transform : rotate(100deg)
}
`;

export const Container = styled.div`
  display: flex;

  transition: opacity 0.2s;
  font-weight: bold;
 
  justify-content: center;
  width: 100%;
  max-width: 270px;

  &:hover {
    opacity: 0.9;
  }

  > div {
    padding: 5px;
    display: flex;
    width: 60px;
    min-width: 60px;
    height: 60px;
    border-radius: 5px;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);
    justify-content: center;
    align-items: center;
    background: #fff;
    margin: 5px;
    flex-direction: column;

    > h3 { 
      color: rgb(150,0,0);
      font-size: 24px;
    }

    > p {
      color: rgb(150,0,0);
      font-size: 12px;
    }


  @media (max-width: 750px) {
    width: 41px;
    min-width: 41px;
    height: 41px;

    > h3 {
   
      font-size: 16px;
    }

    > p {
    
      font-size: 9px;
    }

  }
  }

  > p {
    font-size: 32px;
    margin-top: 10px;
    svg {
      animation: ${rotateAnimation} 1s infinite;
    }
  }

`;
